import { cn } from "~/lib/utils"

export function ValidationMessage({ message }: { message: string[] | string | undefined | null }) {
    if (typeof message === "string") {
        return <p className="text-[0.8rem] font-medium text-destructive">{message}</p>
    }
    if (!message) {
        return null
    }
    return <p className="text-[0.8rem] font-medium text-destructive">{message[0]}</p>
}

export function FormValidationMessage({ variant, message }: { variant: "success" | "error"; message: string }) {
    return (
        <div
            className={cn(
                "p-3 bg-red-100 rounded text-sm border ",
                variant === "success"
                    ? "bg-green-100 border-green-200"
                    : variant === "error"
                    ? "bg-red-100 border-red-200"
                    : "bg-white"
            )}
        >
            {message}
        </div>
    )
}

export function ValidationMessageV2({ message }: { message: string[] | undefined }) {
    if (message === undefined) {
        return <></>
    }
    return <p className="text-[0.8rem] font-medium text-destructive">{message[0]}</p>
}
